export default function TabsHeader({ activeTab, setActiveTab }: any) {

  return (
    <div className="flex border-b">

      <button
        onClick={() => setActiveTab("appointments")}
        className={`px-4 py-4 text-lg font-semibold transition ${
          activeTab === "appointments"
            ? "border-b-2 border-emerald-700 text-emerald-700"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        Appuntamenti
      </button>

      <button
        onClick={() => setActiveTab("slots")}
        className={`px-4 py-4 text-lg font-semibold transition ${
          activeTab === "slots"
            ? "border-b-2 border-emerald-700 text-emerald-700"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        Slot disponibili
      </button>

    </div>
  );
}